import React from 'react'
import Grid from '@mui/material/Grid'
import { DatePickerInput } from './DatePickerInput'
import dayjs, { Dayjs } from 'dayjs'
import { Typography, Box } from '@mui/material'
import { SxProps, Theme } from '@mui/material/styles'
import { t } from '@lingui/macro'

type DateRangePickerInputProps = {
  value: [Date, Date]
  onChange: (range: { start: Date; end: Date }) => void
  label?: string
  sx?: SxProps<Theme>
}

const DateRangePickerInput: React.FC<DateRangePickerInputProps> = ({ value, onChange, label, sx }) => {
  const [startDate, endDate] = value

  const handleStartDateChange = (date: Dayjs | null) => {
    if (date) {
      const newStartDate = date.toDate()
      onChange({ start: newStartDate, end: endDate })
    }
  }

  const handleEndDateChange = (date: Dayjs | null) => {
    if (date) {
      const newEndDate = date.toDate()
      onChange({ start: startDate, end: newEndDate })
    }
  }

  return (
    <Box sx={sx}>
      {label && (
        <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
          {label}
        </Typography>
      )}
      <Grid container spacing={2}>
        <Grid item xs={6}>
          <DatePickerInput label={t`Start Date`} value={dayjs(startDate)} onChange={handleStartDateChange} />
        </Grid>
        <Grid item xs={6}>
          <DatePickerInput label={t`End Date`} value={dayjs(endDate)} onChange={handleEndDateChange} />
        </Grid>
      </Grid>
    </Box>
  )
}

export default DateRangePickerInput
